import { zervantSettingsQueryKey } from '@features/invoicingSettings/constants/zervantSettingsQueryKey'
import { useUpdateAutomaticPaymentRemindersSettings } from '@features/invoicingSettings/modules/paymentsAndReminders'

import { queryClient } from '../../../../../../../config/queryClient'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { InvoiceSettingsForm } from '../types/invoiceSettingsForm'

export const useUpdateAutomaticPaymentReminders = () => {
  const { update, isProcessing } = useUpdateAutomaticPaymentRemindersSettings()

  const updateSettings = ({ automaticPaymentRemindersSettings }: InvoiceSettingsForm) => {
    if (!automaticPaymentRemindersSettings) {
      return
    }

    update(automaticPaymentRemindersSettings, {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.PaymentRemindersSettings)
        queryClient.invalidateQueries(zervantSettingsQueryKey)
      },
    })
  }

  return { update: updateSettings, isProcessing }
}
